var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_27133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8204 21.1553C41.8204 9.30632 31.6993 -0.203318 19.5338 0.589152C9.39726 1.25208 1.1044 9.2225 0.178688 19.2046C-0.747026 29.1866 5.35497 37.6066 14.0875 40.6165C15.0287 40.9365 15.8464 41.5385 16.4327 42.331L19.9041 47.0172C20.421 47.7182 21.4778 47.7182 22.0024 47.0172L25.4738 42.331C26.0678 41.5309 26.8933 40.9365 27.8344 40.6089C35.973 37.7971 41.8204 30.1544 41.8204 21.1553Z",
    fill: "#070A0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 37C29.8366 37 37 29.8366 37 21C37 12.1634 29.8366 5 21 5C12.1634 5 5 12.1634 5 21C5 29.8366 12.1634 37 21 37Z",
    fill: "#FF5368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2581 25.4839H21.9904C22.3594 25.4839 22.6577 25.2024 22.6813 24.8349L23.3801 13.9265C23.4036 13.5277 23.0896 13.1914 22.6891 13.1914H18.5593C18.1589 13.1914 17.8449 13.5277 17.8684 13.9265L18.5672 24.8349C18.5908 25.2024 18.897 25.4839 19.2581 25.4839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9897 27.5762H19.2574C18.8671 27.5762 18.5508 27.8913 18.5508 28.2799V31.0012C18.5508 31.3899 18.8671 31.705 19.2574 31.705H21.9897C22.3799 31.705 22.6963 31.3899 22.6963 31.0012V28.2799C22.6963 27.8913 22.3799 27.5762 21.9897 27.5762Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_27133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartError);
export default __webpack_public_path__ + "static/media/cart_error.df021d01fd08cc0b09843c4a26078e87.svg";
export { ForwardRef as ReactComponent };